import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, Cell } from "recharts";

export const LeadTimeChart = ({ data, selected, onSelect, lang }) => {
  const es = lang === "es";
  const labels = {
    rain_mm: es ? "Lluvia 24 h modelo (mm)" : "24 h model rain (mm)",
    aemet_mm: es ? "AEMET oficial 24 h (mm est.)" : "Official AEMET 24 h (mm est.)",
    confidence: es ? "Confianza (%)" : "Confidence (%)",
  };
  return (
    <div className="h-40 rounded-lg border border-slate-800 bg-[#0B0F19] p-2" data-testid="dana-leadtime-chart">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={data} margin={{ top: 4, right: 4, left: -18, bottom: 0 }}
          onClick={(e) => e?.activeLabel && onSelect(e.activeLabel)}>
          <XAxis dataKey="checkpoint" tick={{ fill: "#94A3B8", fontSize: 10, fontFamily: "monospace" }} stroke="#334155" />
          <YAxis yAxisId="mm" tick={{ fill: "#64748B", fontSize: 9 }} stroke="#334155" />
          <YAxis yAxisId="pct" orientation="right" domain={[0, 100]} tick={{ fill: "#64748B", fontSize: 9 }} stroke="#334155" />
          <Tooltip
            contentStyle={{ background: "#0B0F19", border: "1px solid #334155", fontSize: 11 }}
            labelStyle={{ color: "#E2E8F0" }}
            formatter={(v, k) => [v, labels[k] || k]}
          />
          <Legend wrapperStyle={{ fontSize: 10 }} formatter={(k) => labels[k] || k} />
          <Bar yAxisId="mm" dataKey="rain_mm" fill="#38BDF8" radius={[2, 2, 0, 0]}>
            {data.map((d) => <Cell key={d.checkpoint} fill="#38BDF8" fillOpacity={d.checkpoint === selected ? 1 : 0.35} />)}
          </Bar>
          <Bar yAxisId="mm" dataKey="aemet_mm" fill="#14B8A6" radius={[2, 2, 0, 0]}>
            {data.map((d) => <Cell key={d.checkpoint} fill="#14B8A6" fillOpacity={d.checkpoint === selected ? 1 : 0.35} stroke={d.checkpoint === selected ? "#F59E0B" : "none"} />)}
          </Bar>
          <Line yAxisId="pct" type="monotone" dataKey="confidence" stroke="#A5B4FC" strokeWidth={2} dot={{ r: 3 }} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};
